import { initPreferences } from '@vben/preferences';
import { useUserStore } from '@vben/stores';
import { unmountGlobalLoading } from '@vben/utils';

import { setupIconifyOffline } from './iconify-config';
import { initPrintLogOutbox } from './modules/mes/printer/utils/print-log-outbox';
import { overridesPreferences } from './preferences';
import { useNotificationStore } from './stores/notification';
import { setupAppUpdateGuard } from './utils/app-update';

setupAppUpdateGuard();

// 打印记录离线补交：绑定网络恢复/定时触发
initPrintLogOutbox();

/**
 * 应用初始化完成之后再进行页面加载渲染
 */
async function initApplication() {
  // 初始化 Iconify 离线图标集（在应用启动前加载）
  setupIconifyOffline();
  // name用于指定项目唯一标识
  // 用于区分不同项目的偏好设置以及存储数据的key前缀以及其他一些需要隔离的数据
  const env = import.meta.env.PROD ? 'prod' : 'dev';
  const appVersion = import.meta.env.VITE_APP_VERSION;
  const namespace = `${import.meta.env.VITE_APP_NAMESPACE}-${appVersion}-${env}`;

  // app偏好设置初始化
  await initPreferences({
    namespace,
    overrides: overridesPreferences,
  });

  // 启动应用并挂载
  // vue应用主要逻辑及视图
  const { bootstrap } = await import('./bootstrap');
  await bootstrap(namespace);

  // 初始化通知状态（在应用启动后，仅当用户已登录时）
  const notificationStore = useNotificationStore();
  const userStore = useUserStore();

  // 只有在用户已登录时才获取未读数量
  if (userStore.userInfo) {
    await notificationStore.fetchUnreadCount();
  }

  // 移除并销毁loading
  unmountGlobalLoading();
}

initApplication();
